import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Skeleton from '@eig-builder/core-ui/Skeleton'

export const ContentWrapper = styled.div`
  min-height: 92px;
`

export const ExpireDate = styled.div`
  &.expired {
    color: red;
  }
`

export const StyledIcon = styled(FontAwesomeIcon)`
  color: slategray;
  font-size: 30px;

  transition: font-size .4s ease-in-out;

  :hover {
    font-size: 50px;
  }
`

export const StyledSkeleton = styled(Skeleton)`
  background-color: rgba(0, 0, 0, 0.15) !important;
`
